// Утилиты для работы с телефоном:
//   phoneDigits(input) — строка с любыми символами → только цифры
//   formatPhone(input)  — форматированный вывод с пробелами (для UI)
//   isValidPhone(input) — true если >= 7 цифр

export function phoneDigits(input) {
  if (!input) return '';
  return String(input).replace(/\D/g, '');
}

export function isValidPhone(input) {
  return phoneDigits(input).length >= 7;
}

// Форматирование: +7 777 123 45 67 (KZ/RU), +7 812 345 67 89, универсально.
// Логика: если 11 цифр и начинается с 7 или 8 — формат "+X XXX XXX XX XX".
// Для 10 цифр — "XXX XXX XX XX".
// Для других длин — цифры группами по 3-4-2-2 начиная слева.
export function formatPhone(input) {
  const d = phoneDigits(input);
  if (!d) return '';

  if (d.length === 11 && (d[0] === '7' || d[0] === '8')) {
    return `+${d[0]} ${d.slice(1, 4)} ${d.slice(4, 7)} ${d.slice(7, 9)} ${d.slice(9, 11)}`;
  }
  if (d.length === 10) {
    return `${d.slice(0, 3)} ${d.slice(3, 6)} ${d.slice(6, 8)} ${d.slice(8, 10)}`;
  }
  // Универсальный fallback: пробел каждые 3 цифры
  return d.replace(/(\d{3})(?=\d)/g, '$1 ').trim();
}
